import { z } from 'zod'
import { nullSafeOptionalFirestoreTimestamp } from '../shared/schema'

export const schema = z.object({
  expiresAt: nullSafeOptionalFirestoreTimestamp(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  folderName: z.string(),
  organizationId: z.string(),
  show: z.boolean().optional().default(true),
})

export const empty = Object.freeze(
  schema.parse({
    expiresAt: null,
    updatedAt: null,
    folderName: '',
    organizationId: '',
    show: true,
  })
)

export type FirestoreOrganizationSectionPassCouponFolder = z.infer<
  typeof schema
>
